<script setup lang="ts">
interface Props {
  option: {
    closeLabel:{
      type:string
      default:'닫기'
    }
  }
}
const props = defineProps<Props>();
</script>

<template>
    <AppDialog v-on="$attrs">
        <template #content>
            <slot name="content"></slot>
        </template>
        <template #action="{ close }">
            <AppButton @click="close">{{props.option.closeLabel}}</AppButton>
        </template>
    </AppDialog>
</template>

<style lang="scss" scoped></style>
